import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Checkbox } from "../../components/Checkbox";
import { Icon, IconNameEnum } from "../../components/Icon";
import { RootState } from "../../store";
import { IFilterItem } from "../../types/filters";
import { ColumnFilterProps } from "../../types/filters";
import { NumberFilter } from "./NumberFilter";

export const WeightFilter: React.FC<ColumnFilterProps> = ({
  tableName,
  fieldName,
  filterSelectorValue,
  filterUpdateAction,
}) => {
  const warningId = `${fieldName}Warning`;
  const warningValue = useSelector((state: RootState) => filterSelectorValue(state, warningId));
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Checkbox
          checked={warningValue?.value === true}
          onChange={() => {
            dispatch(
              filterUpdateAction({
                id: warningId,
                name: fieldName,
                operator: "hasWarning" as IFilterItem["operator"],
                value: !warningValue?.value,
              })
            );
          }}
        />
        {t(`${tableName}.filters.hasWarning`)}
        <Icon name={IconNameEnum.warning} style={{ marginLeft: "8px" }} />
      </div>
      <NumberFilter
        tableName={tableName}
        fieldName={fieldName}
        filterSelectorValue={filterSelectorValue}
        filterUpdateAction={filterUpdateAction}
      />
    </>
  );
};
